import successImg from "./interactive-card-details-form-main/images/icon-complete.svg";

const Success = ({ handleFormSubmit }) => {
    const handleContinue = ()=> {
        handleFormSubmit();
    }
    return ( 
        <div className="success success-animation">
            <div className="success-img">
                <img src={successImg} alt="success" />
            </div>
            <div className="success-text">
                <h1>THANK YOU!</h1>
                <p>We've added your card details</p>
            </div>
            <button onClick={handleContinue} className="continue-btn">Continue</button>
        </div>
     );
}
 
export default Success;